// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Dp-zh","delete":"styles_delete__3stL-","update":"styles_update__2FtmO","add":"styles_add__logox"};